// BUG-2268 — how the notes @ list matches what was typed after "@" against a teammate's name.
// Pure (ADR 010 — Isomorphic Services): folds accents and curly quotes so "jose" finds José.

/** Curly and modifier apostrophes that Mac and iOS autocorrect to, folded to the straight one. */
// Built from code points (left quote U+2018, right quote U+2019, modifier apostrophe U+02BC) so the
// characters are readable here and survive an editor's smart-quote handling.
const CURLY_APOSTROPHES = new RegExp(`[${[0x2018, 0x2019, 0x02bc].map((code) => String.fromCharCode(code)).join('')}]`, 'g');

/** Combining marks (the accents left over after NFD decomposition). */
const COMBINING_MARKS = /\p{M}/gu;

/**
 * Fold text for matching: decompose and drop accents, straighten curly apostrophes, lower-case.
 *
 * @param text - A name or a typed query.
 * @returns The comparable form ("José" and "jose" fold alike; "O’B" folds to "o'b").
 */
export function foldForMatch(text: string): string {
  return text.normalize('NFD').replace(COMBINING_MARKS, '').replace(CURLY_APOSTROPHES, "'").toLowerCase();
}

/**
 * Does a typed query match a name: the start of the whole name or of any word in it,
 * ignoring case, accents and curly-versus-straight apostrophes. An empty query matches all.
 *
 * @param name - The teammate's name as saved.
 * @param query - What was typed after "@".
 * @returns `true` when the name should be listed.
 */
export function mentionNameMatches(name: string, query: string): boolean {
  const q = foldForMatch(query.trim());
  if (!q) return true;
  const folded = foldForMatch(name);
  return folded.startsWith(q) || folded.split(/\s+/).some((word) => word.startsWith(q));
}
